import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { LocationStep } from './Location';

async function LoadLocationStep(): Promise<typeof LocationStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-location" */ './Location')).LocationStep;
}

export function LocationLoader(): JSX.Element {
	const loadComponent = useCallback(LoadLocationStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadLocationStep = LoadLocationStep;
